import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import DigitizeImg from "../../../images/location_new/fold5/uk-android-elevate.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Digitize(props) {
  return (
    <div className="digitize_sec p-100" style={{ backgroundColor: "#040404" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Android Application Development Company in UK to Elevate Your
              Business to New Heights
            </h2>
            <p>
              TekRevol is your trusted{" "}
              <Link
                to="/uk/android-app-development-company-london"
                rel="noopener"
                aria-label="TekRevol"
                className="dark_bg"
              >
                Android App development company in UK,
              </Link>{" "}
              dedicated to propelling your business to new heights through our
              expert Android app development services.
            </p>
            <p>
              As a leading Android app development agency, we prioritize
              delivering solutions that ensure your business stays ahead in the
              dynamic mobile domain.
            </p>
            <p>
              Collaborate with us, and let our practical approach to Android
              application development in UK transform your ideas into powerful,
              user-friendly applications that make a real impact.
            </p>
            <Link
              style={{
                backgroundColor: "#fff",
                color: "#040404",
                border: "1px solid #040404",
              }}
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="digitize_img">
            <LazyLoadImage
              src={DigitizeImg}
              effect="blur"
              alt="android-app-development-company-uk"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Digitize;
